import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import ContentPackPage from "@/pages/ContentPackPage";
import AuthCallback from "@/pages/AuthCallback";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route
        path="/conteudo"
        element={
          <ProtectedRoute>
            <ContentPackPage />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="grain-overlay" aria-hidden="true" />
      <Toaster theme="dark" position="bottom-center" />
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
